import React from 'react';
import { MessageCircle, Gauge, FileCheck, ShieldCheck } from 'lucide-react';
import { steps, whatsappLink } from '../data/mock';
import { WhatsAppIcon } from './WhatsAppIcon';

const icons = { MessageCircle, Gauge, FileCheck, ShieldCheck };

const StepCard = ({ step, index }) => {
  const Icon = icons[step.icon];
  return (
    <div className="relative bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg p-6 hover:border-[#FF6B00] transition-colors" data-testid={`step-${index + 1}`}>
      <div className="absolute -top-4 left-6 w-9 h-9 rounded-full bg-[#FF6B00] text-white font-bold flex items-center justify-center text-sm shadow-lg">
        {index + 1}
      </div>
      <div className="w-14 h-14 bg-[#FF6B00]/10 rounded-lg flex items-center justify-center mb-4 mt-2">
        <Icon className="text-[#FF6B00]" size={28} />
      </div>
      <h3 className="text-white font-bold text-lg mb-2 leading-snug">{step.title}</h3>
      <p className="text-gray-400 text-sm leading-relaxed">{step.text}</p>
    </div>
  );
};

const HowItWorks = () => (
  <section id="how" className="py-24 bg-[#0a0a0a]" data-testid="how-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-16">
        <span className="text-[#FF6B00] font-bold text-sm uppercase tracking-wider">Passo a passo</span>
        <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
          Como <span className="text-[#FF6B00]">Funciona</span>
        </h2>
        <p className="text-gray-400 text-lg max-w-3xl mx-auto">
          Do primeiro contato até a peça testada e garantida, em 4 passos simples
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 pt-4">
        {steps.map((s, i) => <StepCard key={s.title} step={s} index={i} />)}
      </div>
      <div className="text-center mt-14">
        <a
          href={whatsappLink("Olá! Quero enviar o problema do meu veículo para diagnóstico.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="how-whatsapp-button"
          className="inline-flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 rounded-md hover:bg-[#1fb857] transition-all duration-300 font-bold text-lg transform hover:scale-105"
        >
          <WhatsAppIcon className="w-6 h-6" />
          Começar pelo WhatsApp
        </a>
      </div>
    </div>
  </section>
);

export default HowItWorks;
